<template>
  <div class="organization-form-tab">
    <validation-observer v-slot="{ handleSubmit }" tag="div">
      <tab
        title="Setup the basics"
        number="1"
        :active="activeTab == 0"
        :done="done[0] || false"
        @click:header="changeTab(0)"
      >
        <validation-observer ref="tab-0" tag="div" class="columns">
          <div class="column is-12">
            <div class="field">
              <validation-provider v-slot="{ errors, failed }" rules="required">
                <label class="label">Organization Name</label>
                <div class="control">
                  <input
                    v-model="model.name"
                    class="input"
                    type="text"
                    :class="{ 'is-danger': failed }"
                  />
                </div>
                <p class="help is-danger">{{ errors[0] }}</p>
              </validation-provider>
            </div>
          </div>
        </validation-observer>
        <div class="structure">
          <template v-for="(item, index) in groups">
            <division-group
              v-model="groups[index]"
              :key="groups[index].groupID"
              :index="index"
              :total="groups.length"
              @deleted="deleteDivision"
              @added="addDivision"
            ></division-group>
          </template>
        </div>
        <div
          class="has-text-centered pt-15"
          v-if="model.organizationID == undefined"
        >
          <button
            class="button is-primary"
            @click="
              /*changeTab(1);*/
              handleSubmit(() => {
                $emit('create', buttons, groups);
              })
            "
          >
            Create Organization
          </button>
        </div>
      </tab>
      <tab
        title="Additional Features (optional)"
        number="2"
        :active="activeTab == 1"
        :done="done[1] || false"
        @click:header="changeTab(1)"
        v-if="!isCreate"
      >
        <validation-observer ref="tab-0" tag="div" class="columns is-multiline">
          <div class="column is-12">
            <div class="field">
              <div class="control">
                <app-checkbox v-model="hasButtons">
                  Submit Form Response
                </app-checkbox>
                <div class="help">
                  Link a form to your project so project team members can easily
                  send in responses
                </div>
              </div>
            </div>
          </div>

          <div class="group-step-2 columns column is-12" v-if="hasButtons">
            <div class="column is-8">
              <button-list-manage
                v-model="buttons"
                :groups="associatedGroup"
                :oid="model.organizationID"
              ></button-list-manage>
            </div>
            <div class="column is-4">
              <div class="image-placeholder"></div>
            </div>
          </div>
        </validation-observer>
        <div class="has-text-centered pt-15">
          <button
            v-if="isCreate"
            class="button is-primary"
            @click="
              handleSubmit(() => {
                $emit('create', buttons, groups);
              })
            "
          >
            Create Organization
          </button>
        </div>
      </tab>
      <div class="has-text-centered pt-15" v-if="!isCreate">
        <button
          class="button is-primary"
          @click="
            handleSubmit(() => {
              $emit('update', buttons, groups);
            })
          "
        >
          Update Organization</button
        >&nbsp;&nbsp;&nbsp;
        <button class="button is-secondary" @click="showDeleteOrganization">
          Delete Organization
        </button>
      </div>
    </validation-observer>
    <confirm-dialog
      v-model="deleteOrganizationDialog"
      :selected="confirmSelected"
      @confirmed="deleteOrganization"
    ></confirm-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import Form from './Form.js';
import AppCheckbox from '../AppCheckbox.vue';
import ConfirmDialog from '@/components/ConfirmDialog.vue';
import DivisionGroup from '@/components/organization/DivisionGroup.vue';
import ButtonListManage from '@/components/ButtonListManage.vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import '@/validation.js';
import Tab from '@/components/tabs/Tab.vue';

export default {
  name: 'OrganizationFormTabs',
  components: {
    ValidationProvider,
    ValidationObserver,
    Tab,
    ConfirmDialog,
    AppCheckbox,
    ButtonListManage,
    DivisionGroup
  },
  extends: Form,
  data() {
    return {
      model: {},
      activeTab: 0,
      done: {},
      deleteOrganizationDialog: false,
      confirmSelected: null,
      buttons: [],
      groups: []
    };
  },
  computed: {
    hasButtons: {
      get() {
        return this.buttons.length > 0;
      },
      set(newValue) {
        if (newValue && this.buttons.length == 0) {
          this.buttons.push({
            title: '',
            titleLink: '',
            groupID: '',
            organizationID: this.model.organizationID
          });
        } else {
          this.buttons = [];
        }
      }
    },
    isCreate() {
      return !this.model.organizationID;
    },
    associatedGroup() {
      if (this.model.organizationID) {
        return this.$store.getters['groups/flatTree'](
          -1,
          this.model.organizationID
        );
      }
    }
  },
  watch: {
    model(value) {
      if (value) {
        let buttons = [];
        if (value.groups) {
          for (let i = 0; i < value.groups.length; i++) {
            for (let j = 0; j < value.groups[i].buttons.length; j++) {
              buttons.push(value.groups[i].buttons[j]);
            }
          }
        }

        if (buttons.length > 0) {
          this.buttons = buttons;
        } else {
          this.buttons = [];
        }
      } else {
        this.buttons = [];
      }
      this.activeTab = 0;

      let groups = [];
      if (value.groups) {
        for (let i = 0; i < value.groups.length; i++) {
          if (value.groups[i].organizationLevel == 'Division') {
            let workgroups = [];
            for (let y = 0; y < value.groups.length; y++) {
              //get division childs
              if (value.groups[i].groupID == value.groups[y].parentGroupID) {
                workgroups.push(value.groups[y]);
              }
            }

            groups.push({
              isAdd: false,
              division: value.groups[i],
              workgroups: workgroups
            });
          }
        }
      }
      //add the empty one to be able to add more
      groups.push(this.getNewDivisionObject());
      this.groups = groups;
    }
  },
  methods: {
    getNewDivisionObject() {
      return {
        isAdd: true,
        division: {
          name: '',
          organizationLevel: 'Division',
          parentGroupName: this.model.name
        },
        workgroups: []
      };
    },
    validateTab(ref, callback) {
      this.$refs[ref].validate().then(valid => {
        if (valid) {
          callback();
        }
      });
    },
    async changeTab(idx) {
      if (idx == this.activeTab) {
        // is the same tab, do nothing
        return;
      }
      if (idx > this.activeTab) {
        // the requested tab is bigger so we must validate all tabs in between
        for (let i = 0; i < idx; i++) {
          const ref = `tab-${i}`;
          if (this.$refs[ref] != undefined) {
            const valid = await this.$refs[ref].validate();
            if (valid) {
              this.$set(this.done, i, true);
            } else {
              this.activeTab = i;
              return;
            }
          }
        }
      } else {
        // we are going back in steps so all should be undone
        for (const key in this.done) {
          if (this.done.hasOwnProperty(key)) {
            this.$set(this.done, key, false);
          }
        }
      }
      this.activeTab = idx;
    },
    showDeleteOrganization() {
      this.deleteOrganizationDialog = true;
    },
    deleteOrganization() {
      this.axiosRequest('delete', 'Organizations/' + this.model.organizationID)
        .then(() => {
          this.$store.commit(
            'organizations/deleteById',
            this.model.organizationID
          );
          this.showSuccessMessage('Organization deleted');
        })
        .catch(error => {
          this.showErrorMessage(error);
        })
        .finally(() => {
          this.deleteOrganizationDialog = false;
          this.confirmSelected = null;
          //this.create = false;
          this.$emit('close');
        });
    },
    addDivision() {
      this.groups.push(this.getNewDivisionObject());
    },
    deleteDivision(division) {
      for (let i = 0; i < this.groups.length; i++) {
        if (this.groups[i] == division) {
          this.groups.splice(i, 1);
        }
      }
    }
  }
};
</script>
<style lang="scss">
.organization-form-tab {
  .group-step-2 {
    padding-left: 36px;
  }

  .help {
    padding-left: 26px;
  }

  .image-placeholder {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 190px;
    background: url('../../assets/images/button-preview-organization.png') 50%
      50% no-repeat;
    background-size: cover;
    margin-left: 20px;
  }

  .structure {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
